import { EmailIcon } from '@change/ds-icons/EmailIcon';
import { FacebookRegularIcon } from '@change/ds-icons/FacebookRegularIcon';
import { InstagramIcon } from '@change/ds-icons/InstagramIcon';
import { LinkedInIcon } from '@change/ds-icons/LinkedInIcon';
import { RedditIcon } from '@change/ds-icons/RedditIcon';
import { TikTokIcon } from '@change/ds-icons/TikTokIcon';
import { TwitterIcon } from '@change/ds-icons/TwitterIcon';
import type { Icon } from '@change/ds-icons/types';
import { YouTubeIcon } from '@change/ds-icons/YouTubeIcon';

// Mimics Elections logic for social platforms, but only keeps a subset of common SocialPlatforms; omitting Tumblr, Substack, Bluesky
export const SOCIAL_PLATFORMS: SocialPlatform[] = [
	'facebook',
	'x',
	'instagram',
	'reddit',
	'youtube',
	'tiktok',
	'linkedin',
	'mailto',
];

type SocialIconVariant = 'facebook' | 'twitter' | 'instagram' | 'reddit' | 'default';
export type SocialPlatform = 'facebook' | 'x' | 'instagram' | 'reddit' | 'youtube' | 'tiktok' | 'linkedin' | 'mailto';
export type SocialLink = {
	platform: SocialPlatform;
	url: string;
	icon: React.FC<Icon>;
	variant: SocialIconVariant;
	domains: readonly string[];
};

type SocialPlatformConfig = Record<
	SocialPlatform,
	{ icon: React.FC<Icon>; variant: SocialIconVariant; domains: readonly string[] }
>;
export const SOCIAL_PLATFORM_CONFIG: SocialPlatformConfig = {
	facebook: { icon: FacebookRegularIcon, variant: 'facebook', domains: ['facebook.com', 'fb.com'] },
	x: { icon: TwitterIcon, variant: 'twitter', domains: ['x.com', 'twitter.com'] },
	instagram: { icon: InstagramIcon, variant: 'instagram', domains: ['instagram.com'] },
	reddit: { icon: RedditIcon, variant: 'reddit', domains: ['reddit.com'] },
	// eslint-disable-next-line @change-corgi/youtube-embeds-nocookies
	youtube: { icon: YouTubeIcon, variant: 'default', domains: ['youtube.com', 'youtu.be'] },
	tiktok: { icon: TikTokIcon, variant: 'default', domains: ['tiktok.com'] },
	linkedin: { icon: LinkedInIcon, variant: 'default', domains: ['linkedin.com'] },
	mailto: { icon: EmailIcon, variant: 'default', domains: ['mailto'] },
};
